import { writable, get } from "svelte/store";
import type { OpportunityOptionsResponse } from "./types";

const DEFAULT_URL = process.env.SVELTE_APP_REMOTE_URL;
const optionsUrl = `${DEFAULT_URL}/api/sync/options`;

interface OptionsState {
  data: OpportunityOptionsResponse | null;
  loading: boolean;
  loaded: boolean;
}

const createOptionsStore = () => {
  const { subscribe, set, update } = writable<OptionsState>({
    data: null,
    loading: false,
    loaded: false,
  });

  let fetchPromise: Promise<OpportunityOptionsResponse> | null = null;

  const fetchOptions = async (force = false) => {
    const state = get({ subscribe });
    if (state.loaded && !force) return state.data;
    if (fetchPromise && !force) return fetchPromise;

    fetchPromise = (async () => {
      update((s) => ({ ...s, loading: true }));
      try {
        const res = await fetch(optionsUrl);
        if (!res.ok) throw new Error("Failed to fetch options");
        const data: OpportunityOptionsResponse = await res.json();
        set({ data, loading: false, loaded: true });
        return data;
      } catch (err) {
        update((s) => ({ ...s, loading: false }));
        console.error("Options fetch error:", err);
        throw err;
      } finally {
        fetchPromise = null;
      }
    })();

    return fetchPromise;
  };

  const reset = () => set({ data: null, loading: false, loaded: false });

  return { subscribe, fetchOptions, reset };
};

export const opportunityOptions = createOptionsStore();
